module.exports = __webpack_public_path__ + "static/img/icon_wechat_green.70d8831.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_wechat_green.png
// module id = qaD3
// module chunks = 1